import PostAddIcon from "@mui/icons-material/PostAdd";
import { Box, Button, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useState } from "react";
import AddBlogModal from "./components/AddBlogModal/AddBlogModal";
import AdminSideNavLayout from "./components/AdminSideNavLayout/AdminSideNavLayout";
import GeneratedBlogsList from "./components/GeneratedBlogsList/GeneratedBlogsList";
import adminDashboardStyles from "./AdminDashboard.styles";

const AdminBlogsPage = () => {
  const styles = adminDashboardStyles;
  const [addModalOpen, setAddModalOpen] = useState(false);

  const handleGenerated = (jobId: string) => {
    setAddModalOpen(false);
    // Optional: trigger refresh of list or polling for jobId
  };

  return (
    <AdminSideNavLayout>
      <Box sx={styles.root}>
        <Box sx={{ ...styles.section, mb: 3 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4 }}
            >
              <Typography variant="h4" fontWeight={700}>
                Generated Blogs
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Create and manage your blogs
              </Typography>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.1 }}
            >
              <Button
                variant="contained"
                startIcon={<PostAddIcon />}
                onClick={() => setAddModalOpen(true)}
                sx={styles.addButton}
              >
                Add Blog
              </Button>
            </motion.div>
          </Box>
        </Box>
        <Box sx={styles.section}>
          <GeneratedBlogsList />
        </Box>
      </Box>
      <AddBlogModal
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onGenerated={handleGenerated}
      />
    </AdminSideNavLayout>
  );
};

export default AdminBlogsPage;
